import * as React from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Avatar, Box, Button, Card, CardActions, CircularProgress, Container, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { Form, required, TextInput, useLogin } from 'react-admin';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

import { useTranslate, useNotify } from 'react-admin';

import Logo from './Logo';

// interface FormValues {
//   username?: string;
//   password?: string;
// }

const Login = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const notify = useNotify();
  const login = useLogin();
  const location = useLocation();

  const { instance } = useMsal();

  // const handleRedirect = () => {
  //   instance
  //     .loginRedirect({
  //       ...loginRequest,
  //       prompt: 'create',
  //     })
  //     .catch(() => {
  //       notify('SSO login failed', { type: 'error' });
  //     });
  // };

  const handleSSO = () => {
    setLoading(true);
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: 'select_account', // Forces account selection to avoid "auto-logging" the wrong user
      })
      .catch((error) => {
        setLoading(true);
        notify('SSO login failed', { type: 'error' });
      });
  };

  // const handleSubmit = (auth: FormValues) => {
  //   setLoading(true);
  //   login(auth, location.state ? (location.state as any).nextPathname : '/').catch((error: Error) => {
  //     setLoading(false);
  //     notify(
  //       typeof error === 'string'
  //         ? error
  //         : typeof error === 'undefined' || !error.message
  //         ? 'ra.auth.sign_in_error'
  //         : error.message,
  //       {
  //         type: 'error',
  //         messageArgs: {
  //           _: typeof error === 'string' ? error : error && error.message ? error.message : undefined,
  //         },
  //       }
  //     );
  //   });
  // };

  return (
    <>
      {/* <Form onSubmit={handleSubmit} noValidate>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '50vh',
            alignItems: 'center',
            justifyContent: 'flex-start',
            background: 'url(https://source.unsplash.com/featured/1600x900)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <Card sx={{ minWidth: 300, marginTop: '6em' }}>
            <Box
              sx={{
                margin: '1em',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Avatar sx={{ bgcolor: 'secondary.main' }}>
                <LockIcon />
              </Avatar>
            </Box>
            <Box
              sx={{
                marginTop: '1em',
                display: 'flex',
                justifyContent: 'center',
                color: (theme) => theme.palette.grey[500],
              }}
            ></Box>
            <Box sx={{ padding: '0 1em 1em 1em' }}>
              <Box sx={{ marginTop: '1em' }}>
                <TextInput
                  autoFocus
                  source="username"
                  label={translate('ra.auth.username')}
                  disabled={loading}
                  validate={required()}
                />
              </Box>
              <Box sx={{ marginTop: '1em' }}>
                <TextInput
                  source="password"
                  label={translate('ra.auth.password')}
                  type="password"
                  disabled={loading}
                  validate={required()}
                />
              </Box>
            </Box>
            <CardActions sx={{ padding: '0 1em 1em 1em' }}>
              <Button variant="contained" type="submit" color="primary" disabled={loading} fullWidth>
                {loading && <CircularProgress size={25} thickness={2} />}
                {translate('ra.auth.sign_in')}
              </Button>
            </CardActions>
          </Card>
        </Box>
      </Form> */}
      {/* <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: 'url(https://source.unsplash.com/featured/1600x900)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Card sx={{ minWidth: 300 }}>
          <CardActions>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              fullWidth
              onClick={handleRedirect}
            >
              {loading && <CircularProgress size={25} thickness={2} />}
              {translate('auth.sso_sign_in')}
            </Button>
          </CardActions>
        </Card>
      </Box> */}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="xs">
          <Card
            sx={{
              padding: '3.5em 2em',
              borderRadius: 3,
              boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
              textAlign: 'center',
            }}
          >
            <Box sx={{ marginBottom: '1.5em' }}>
              <Logo />
            </Box>

            <Typography variant="h5" sx={{ fontWeight: 600, color: '#003b5c', mb: 1 }}>
              Billing Mart
            </Typography>

            <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
              Please sign in with your corporate account to access the portal.
            </Typography>

            <Button
              variant="contained"
              fullWidth
              onClick={handleSSO}
              disabled={loading}
              sx={{
                padding: '12px',
                color: 'primary',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '1rem',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: 'primary',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                },
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign in with SSO'}
            </Button>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Login;
